<template>
  <div class="cmc-flip-card-wrapper">
    <div class="cmc-flip-card-inner">
      <!-- Frente de la Tarjeta -->
      <div class="cmc-flip-card-front">
        <div class="vip-card-bg-circle"></div>
        <div class="vip-card-bg-circle" style="bottom: -80px; left: -40px; top: auto; right: auto; width: 250px; height: 250px;"></div>
        
        <div class="vip-card-top">
          <img src="@/assets/logos/Promolider.png" alt="Promolíder" class="vip-logo-img" />
          <div class="vip-chip"></div>
        </div>
        
        <div class="vip-card-middle">
          <div class="vip-tier-name">
            <svg class="vip-crown-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.735H5.81a1 1 0 0 1-.957-.735L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"/>
              <path d="M5 21h14"/>
            </svg>
            <span>{{ membershipName }}</span>
          </div>
        </div>
        
        <div class="vip-card-bottom">
          <div class="vip-info-group">
            <span class="vip-info-label">Miembro</span>
            <span class="vip-info-value">{{ userName }}</span>
          </div>
          <div class="vip-info-group" style="text-align: right;">
            <span class="vip-info-label">Valor</span>
            <span class="vip-info-value" style="color: #4ade80;">${{ membershipPrice }}/año</span>
          </div>
        </div>
      </div>

      <!-- Dorso de la Tarjeta -->
      <div class="cmc-flip-card-back">
        <div class="vip-card-strip"></div>
        <div class="vip-card-back-content">
          <h4 class="vip-back-title">Beneficios Activos</h4>
          <div class="vip-back-grid">
            <div class="vip-back-item">
              <div class="vip-back-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="5" x2="5" y2="19"></line><circle cx="6.5" cy="6.5" r="2.5"></circle><circle cx="17.5" cy="17.5" r="2.5"></circle></svg>
              </div>
              <div class="vip-back-text"><span class="vip-back-label">IVA</span><span class="vip-back-value">{{ formatBenefit(membership ? membership.iva : 0) }}</span></div>
            </div>
            <div class="vip-back-item">
              <div class="vip-back-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>
              </div>
              <div class="vip-back-text"><span class="vip-back-label">Desc Cursos</span><span class="vip-back-value">{{ formatBenefit(membership ? membership.disc_purchases_course : 0) }}</span></div>
            </div>
            <div class="vip-back-item">
              <div class="vip-back-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>
              </div>
              <div class="vip-back-text"><span class="vip-back-label">Corte Binario</span><span class="vip-back-value">{{ formatBenefit(membership ? membership.pay_in_binary : 0) }}</span></div>
            </div>
            <div class="vip-back-item">
              <div class="vip-back-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
              </div>
              <div class="vip-back-text"><span class="vip-back-label">Bono Rápido</span><span class="vip-back-value">{{ formatBenefit(membership ? membership.fast_cash_bonus : 0) }}</span></div>
            </div>
            <div class="vip-back-item">
              <div class="vip-back-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
              </div>
              <div class="vip-back-text"><span class="vip-back-label">Comisión Dir</span><span class="vip-back-value">{{ formatBenefit(membership ? membership.comission : 0) }}</span></div>
            </div>
            <div class="vip-back-item">
              <div class="vip-back-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06-.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
              </div>
              <div class="vip-back-text"><span class="vip-back-label">Venta Cursos</span><span class="vip-back-value">{{ formatBenefit(membership ? membership.course_selling_bonus : 0) }}</span></div>
            </div>
            <div class="vip-back-item">
              <div class="vip-back-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg>
              </div>
              <div class="vip-back-text"><span class="vip-back-label">Bono Productor</span><span class="vip-back-value">{{ formatBenefit(membership ? membership.productor_bonus : 0) }}</span></div>
            </div>
          </div>
        </div>
        <img src="@/assets/logos/Promolider.png" alt="Promolíder" class="vip-logo-back" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VipMembershipCard',
  props: {
    membership: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    membershipName() {
      return this.membership && this.membership.account ? this.membership.account : 'Gratis';
    },
    membershipPrice() {
      if (!this.membership || !this.membership.price) return '0.00';
      return parseFloat(this.membership.price).toFixed(2);
    },
    userName() {
      if (!this.user) return 'Usuario';
      const name = this.user.name || '';
      const lastName = this.user.last_name || '';
      return `${name} ${lastName}`.trim() || 'Usuario';
    },
  },
  methods: {
    formatBenefit(val) {
      if (val === undefined || val === null) return '0%';
      if (String(val).includes('%')) return String(val);
      return `${val}%`;
    },
  },
};
</script>

<style scoped>
/* Tarjeta Premium Flip 3D */
.cmc-flip-card-wrapper {
  perspective: 1500px;
  width: 100%;
  max-width: 560px;
  aspect-ratio: 1.586 / 1;
  min-height: 280px;
  max-height: 350px;
  margin: 0 auto 30px auto;
}

.cmc-flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: left;
  transition: transform 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transform-style: preserve-3d;
  cursor: pointer;
}

.cmc-flip-card-wrapper:hover .cmc-flip-card-inner {
  transform: rotateY(180deg);
}

.cmc-flip-card-front, .cmc-flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border-radius: 20px;
  box-shadow: 0 20px 40px -10px rgba(34, 197, 94, 0.4);
  overflow: hidden;
}

.cmc-flip-card-front {
  background: linear-gradient(135deg, #22c55e 0%, #064e3b 100%);
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: white;
  z-index: 2;
  transform: rotateY(0deg);
}

.cmc-flip-card-front::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0) 50%);
  pointer-events: none;
}

.vip-card-bg-circle {
  position: absolute;
  width: 250px; height: 250px;
  border-radius: 50%;
  background: rgba(255,255,255,0.1);
  top: -80px; right: -40px;
}

.vip-card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}

.vip-logo-img {
  height: 32px;
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.vip-chip {
  width: 48px;
  height: 36px;
  background: linear-gradient(135deg, #fde047 0%, #ca8a04 100%);
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  box-shadow: inset 0 1px 2px rgba(255,255,255,0.4), 0 2px 6px rgba(0,0,0,0.2);
}
.vip-chip::after {
  content: '';
  position: absolute;
  top: 50%; left: 0; right: 0;
  height: 1px;
  background: rgba(0,0,0,0.25);
}

.vip-card-middle {
  position: relative;
  z-index: 2;
}

.vip-crown-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
}

.vip-tier-name {
  font-size: 34px;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 14px;
  text-shadow: 0 2px 10px rgba(0,0,0,0.3);
  font-family: 'Outfit', sans-serif;
}

.vip-card-bottom {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;
}

.vip-info-group {
  display: flex;
  flex-direction: column;
}
.vip-info-label {
  font-size: 12px;
  text-transform: uppercase;
  opacity: 0.8;
  letter-spacing: 1px;
  font-family: 'Plus Jakarta Sans', sans-serif;
}
.vip-info-value {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: 'Outfit', sans-serif;
}

/* BACK STYLES */
.cmc-flip-card-back {
  background: linear-gradient(135deg, #22c55e 0%, #064e3b 100%);
  transform: rotateY(180deg);
  border: 1px solid rgba(255,255,255,0.1);
  z-index: 1;
}

.vip-card-strip {
  width: 100%;
  height: 50px;
  background: rgba(0,0,0,0.85);
  margin-top: 24px;
}

.vip-card-back-content {
  padding: 16px 28px;
}

.vip-back-title {
  font-size: 13px;
  color: rgba(255,255,255,0.9);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0 0 10px 0;
  font-weight: 700;
}

.vip-back-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 16px;
}

.vip-back-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.vip-back-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  background: #064e3b;
  color: #4ade80;
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.2);
  flex-shrink: 0;
}

.vip-back-text {
  display: flex;
  flex-direction: column;
}
.vip-back-label {
  font-size: 10px;
  color: rgba(255,255,255,0.8);
  text-transform: uppercase;
  line-height: 1.2;
}
.vip-back-value {
  font-size: 14px;
  font-weight: 700;
  color: white;
  line-height: 1.2;
}

.vip-logo-back {
  position: absolute;
  bottom: 24px;
  right: 28px;
  height: 24px;
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

@media (max-width: 640px) {
  .cmc-flip-card-wrapper {
    height: 340px;
  }
  .vip-tier-name {
    font-size: 26px;
  }
  .vip-card-front {
    padding: 20px;
  }
  .vip-card-back-content {
    padding: 12px 20px;
  }
  .vip-back-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }
}
</style>
